import { type Allowances } from 'components/quoting/quotes/flat_allowances/FlatAllowanceExplorer'
import { convertGrapeMoneyToNumber } from 'utils'
import { type QuotingQuoteAllowance } from 'utils/web_api.schemas'

export function convertSavedAllowancesToFormFormat (savedAllowances: QuotingQuoteAllowance[]): Allowances['allowances'] {
  return savedAllowances.map(allowance => {
    const allowanceClass = allowance.location_id && allowance.location_type
      ? {
          location_id: allowance.location_id,
          location_type: allowance.location_type,
        }
      : undefined

    return {
      class: allowanceClass,
      flat_config: {
        employee_amount: allowance.employee_amount != null ? convertGrapeMoneyToNumber(allowance.employee_amount) : 550,
        spouse_amount: allowance.spouse_amount != null ? convertGrapeMoneyToNumber(allowance.spouse_amount) : 550,
        dependent_amount: allowance.dependent_amount != null ? convertGrapeMoneyToNumber(allowance.dependent_amount) : 250,
        max_dependent_count: allowance.max_dependent_count ?? 10,
      },
    }
  })
}

export function isDynamicAllowance (allowances: QuotingQuoteAllowance[]): boolean {
  return allowances.some(allowance => allowance.coverage_percentile != null)
}

export function getDynamicAllowance (allowances: QuotingQuoteAllowance[]): QuotingQuoteAllowance | undefined {
  return allowances.find(allowance => allowance.coverage_percentile != null)
}

export function convertDynamicAllowanceToFilterValues (dynamicAllowance: QuotingQuoteAllowance) {
  return {
    employerEmployeeContribution: (dynamicAllowance.employee_contribution_percentage ?? 100) / 100,
    employerSpouseContribution: (dynamicAllowance.spouse_contribution_percentage ?? 50) / 100,
    employerChildContribution: (dynamicAllowance.dependent_contribution_percentage ?? 50) / 100,
  }
}
